export default __webpack_public_path__ + "static/media/Equipe (Real Size).683ddf3b.svg";